// Exemple de modification à apporter à votre slice Redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import JobService from "services/JobService";

export const fetchJobs = createAsyncThunk(
  "jobs/fetchJobs",
  async ({ page = 1, limit = 6 }, { rejectWithValue }) => {
    try {
      const response = await JobService.getJobs(page, limit);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.data?.message || "Erreur de récupération des jobs"
      );
    }
  }
);

export const createJob = createAsyncThunk(
  "jobs/createJob",
  async (jobData, { rejectWithValue }) => {
    try {
      const response = await JobService.createJob(jobData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const updateJob = createAsyncThunk(
  "jobs/updateJob",
  async ({ jobId, updatedJobData }, { rejectWithValue }) => {
    try {
      const response = await JobService.UpdateJob(jobId, updatedJobData);

      return { jobId, updatedJob: response.data };
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const deleteJob = createAsyncThunk(
  "jobs/deleteJob",
  async (jobId, { rejectWithValue }) => {
    try {
      await JobService.deleteJob(jobId);
      return jobId;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

export const fetchOneJob = createAsyncThunk(
  "jobs/fetchOneJob",
  async (jobId, { rejectWithValue }) => {
    try {
      const response = await JobService.getOneJob(jobId);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.data.message || "Erreur");
    }
  }
);

const initialState = {
  jobs: [],
  job: null,
  loading: false,
  isLoading: false,
  error: null,
  page: 1,
  totalPages: 1,
};

const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    hideLoading: (state, action) => {
      state.loading = false;
    },
    hideError: (state, action) => {
      state.error = null;
    },
    clearJobDetails: (state) => {
      state.job = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload.data;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Create job
      .addCase(createJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs.push(action.payload);
      })
      .addCase(createJob.rejected, (state, action) => {
        state.loading = false;

        state.error = action.error.message;
      })
      // Update job
      .addCase(updateJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJob.fulfilled, (state, action) => {
        const { jobId, updatedJob } = action.payload;
        const index = state.jobs.findIndex((job) => job.id === jobId);
        if (index !== -1) {
          state.jobs[index] = { ...state.jobs[index], ...updatedJob };
        }
        state.loading = false;
      })
      .addCase(updateJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Delete job
      .addCase(deleteJob.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJob.fulfilled, (state, action) => {
        const jobId = action.payload;
        state.jobs = state.jobs.filter((job) => job.id !== jobId);
        state.loading = false;
      })
      .addCase(deleteJob.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch one job
      .addCase(fetchOneJob.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchOneJob.fulfilled, (state, action) => {
        state.job = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchOneJob.rejected, (state, action) => {
        state.error = action.error.message;
        state.isLoading = false;
      });
  },
});

export default jobsSlice.reducer;
export const { showLoading, hideLoading, hideError, clearJobDetails } =
  jobsSlice.actions;
